import { useNavigate } from 'react-router-dom'

import {
  Box,
  type ColorUnion,
  Icon,
  Tag,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

// import { observer } from 'mobx-react'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { useCostCenterMemberships } from 'modules/expenses/hooks/useCostCenterMemberships'
import { Expensable } from 'modules/expenses/types/Expensable'

interface Props extends PermissionsProps, CustomizationProps, WithCustomizationFieldsProps {
  expensable: Expensable
}

const _COLORS: ColorUnion[] = [
  'tangerine',
  'purple',
  'lime',
  'neutral',
  'viridian',
  'radical',
  'grey',
  'malibu',
  'champagne',
  'grey3',
  'fuchsia',
  'negative',
  'grey4',
  'brand',
  'accent',
  'correct',
  'wrong',
  'grey5',
  'terciary',
  'brandLight',
  'brandLightNegative',
  'transparent',
  'ai',
]

const CostCenters = ({ expensable }: Props) => {
  const [open, toggle] = useToggle(false)
  const { loading, memberships } = useCostCenterMemberships(
    stringToDate(expensable?.effectiveOn, 'backend_datetime').toDate(),
    expensable?.owner?.id
  )
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (loading || memberships.length === 0) return null

  return (
    <Box paddingBottom="s8" flexDirection="column">
      <Box paddingBottom="s4" flexDirection="row" alignItems="center" gap="s8">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {i18n.t('expenses_v2.forms.fields.cost_centers.label')}
        </Text.Normal>
        <Tooltip.CallToAction
          attachment="bottom center"
          textAlign="center"
          open={open}
          toggle={toggle}
          title={i18n.t('expenses_v2.forms.fields.cost_centers.tooltip.title')}
          description={i18n.t('expenses_v2.forms.fields.cost_centers.tooltip.description')}
          buttonLabel={i18n.t('expenses_v2.forms.fields.cost_centers.tooltip.button_label')}
          onClick={() => navigate(navigation.settings.finance.costCenters.fullPath())}
        >
          <Icon.Small icon="question" encircled="grey800" />
        </Tooltip.CallToAction>
      </Box>
      <Box flexDirection="row" alignItems="flexStart" flexWrap="wrap" gap="s8">
        {memberships.map((membership, index) => (
          // 0 % 10 = 0, 1 % 10 = 1, ..., 11 % 10 = 1, 12 % 10 = 2, ...
          <Tag key={membership.id} type={_COLORS[index % _COLORS.length]}>
            {membership.costCenter.name}({membership.percentage}%)
          </Tag>
        ))}
      </Box>
    </Box>
  )
}

export default withCustomizationFields(CostCenters)
